import React, { useEffect, useState } from 'react';
import { nav, profile } from '../mock';
import { Menu, X } from 'lucide-react';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? 'bg-[#0a0a0a]/85 backdrop-blur border-b border-neutral-900'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <a href="#top" className="font-display text-[15px] tracking-wider text-white">
          {profile.shortName}
        </a>

        <nav className="hidden md:flex items-center gap-9 mono text-[11px] tracking-[0.18em] text-neutral-300">
          {nav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="hover:text-[#ED2D5C] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="hidden md:inline-flex items-center gap-2 px-4 py-2 border border-neutral-700 hover:border-[#ED2D5C] mono text-[11px] tracking-[0.18em] text-white hover:text-[#ED2D5C] transition-colors"
        >
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#ED2D5C]" />
          HIRE ELLIS
        </a>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0a0a0a] border-t border-neutral-900">
          <div className="flex flex-col p-6 gap-5 mono text-[12px] tracking-[0.18em] text-neutral-300">
            {nav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="hover:text-[#ED2D5C]"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-2 px-4 py-2 border border-neutral-700 self-start text-white"
            >
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#ED2D5C]" />
              HIRE ELLIS
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
